import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompanyDetails({ payload }) {
  try {
    const res = yield call(API.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyPickupAddress({ payload }) {
  try {
    const res = yield call(API.fetchPickupAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyPickupAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyPickupAddressFailure(err?.response?.data));
  }
}

export function* handleFetchCompanyBillingAddress({ payload }) {
  try {
    const res = yield call(API.fetchBillingAddressForCompany, payload);
    const { data } = res;
    yield put(actions.fetchCompanyBillingAddressSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyBillingAddressFailure(err?.response?.data));
  }
}

export function* handleAddUser({ payload }) {
  try {
    const res = yield call(API.addUser, payload.data);
    const { data } = res;
    yield put(actions.addUserSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.addUserFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.addUserFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* addUserSaga() {
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompanyDetails);
  yield takeLatest(actions.addUser.type, handleAddUser);
  yield takeLatest(
    actions.fetchCompanyPickupAddress.type,
    handleFetchCompanyPickupAddress
  );
  yield takeLatest(
    actions.fetchCompanyBillingAddress.type,
    handleFetchCompanyBillingAddress
  );
}
